import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Globals } from "../../../../globals";
import { ConfigurationServices } from "../../services";
import { ConfigurationTicketPrintPage } from '../configuration-ticket-print/configuration-ticket-print';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the ConfigurationRoomsCreatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-tickets-create',
  templateUrl: 'configuration-tickets-create.html',
})
export class ConfigurationTicketsCreatePage {

  public form: FormGroup;
  public ticket_heafoot: any;
  update_state: boolean = false;
  callback: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public fb: FormBuilder,
    private toastCtrl: ToastController,
    public configurationServices: ConfigurationServices,
    public globals: Globals,
    public translate: TranslateService) {

    //Params
    this.update_state = this.navParams.get('update_state');


    if (this.navParams.get('update_state')) {
      this.ticket_heafoot = this.navParams.get('headfooter');
      this.form = fb.group({
        logo: [this.ticket_heafoot.header.logo],
        company: [this.ticket_heafoot.header.company],
        address: [this.ticket_heafoot.header.address],
        phone: [this.ticket_heafoot.header.phone],
        email: [this.ticket_heafoot.header.email],
        footer: [this.ticket_heafoot.footer],
        show_time: [this.ticket_heafoot.show_time],
        waiter: [this.ticket_heafoot.header.waiter],
        room: [this.ticket_heafoot.header.room],
        table: [this.ticket_heafoot.header.table],
        show_client: [this.ticket_heafoot.show_client],
      });
    } else {
      this.form = fb.group({
        logo: [false],
        company: [false],
        address: [false],
        phone: [false],
        email: [false],
        footer: [false],
        show_time: [false],
        waiter: [false],
        room: [false],
        table: [false],
        show_client: [false],
      });
    }
  }


  submit() {
    if (this.form.valid) {
      if (!this.update_state) {
        //this.insert();
      } else {
        this.update();
      }
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-introduce'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  update() {


    var _map = {
      logo: this.form.value.logo,
      company: this.form.value.company,
      address: this.form.value.address,
      phone: this.form.value.phone,
      email: this.form.value.email,
      waiter: this.form.value.waiter,
      room: this.form.value.room,
      table: this.form.value.table,
    };

    var _array_tickets = {
      header: _map,
      footer: this.form.value.footer,
      show_time: this.form.value.show_time,
      show_client: this.form.value.show_client
    };

    this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'tickets': _array_tickets,
    }).then(() => {
      this.globals.GAtrackView('Sales', 'Sales - Ticket - Configuration', this.globals.restaurant.email, 'Create/Update', 'Update configuration ticket', 'Sales', '');
      this.ticket_heafoot.header.logo = this.form.value.logo;
      this.ticket_heafoot.header.company = this.form.value.company;
      this.ticket_heafoot.header.address = this.form.value.address;
      this.ticket_heafoot.header.phone = this.form.value.phone;
      this.ticket_heafoot.header.email = this.form.value.email;
      this.ticket_heafoot.footer = this.form.value.footer;
      this.ticket_heafoot.show_time = this.form.value.show_time;
      this.ticket_heafoot.header.waiter = this.form.value.waiter;
      this.ticket_heafoot.header.room = this.form.value.room;
      this.ticket_heafoot.header.table = this.form.value.table;
      this.ticket_heafoot.show_client = this.form.value.show_client;

      this.navCtrl.setRoot(ConfigurationTicketPrintPage, { headfooter: this.ticket_heafoot });

    });
  }


}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-tickets/configuration-tickets-create/configuration-tickets-create.ts